<template>
  <div class="user-dashboard">
    <!-- Auto-redirect to new dashboard -->
  </div>
</template>

<script>
export default {
  name: 'UserDashboard',
  mounted() {
    // Automatically redirect to new dashboard
    this.$router.replace('/dashboard/new');
  }
};
</script>

<style scoped>
.user-dashboard {
  padding: 20px;
}
</style>